module.exports = __webpack_public_path__ + "img/logo-light.854d2d17.png";